import React from 'react';
import './onboard-table-partner-style.scss';

const OnboardTablePartner = (props) => {

    const {body, header} = props;

    const renderBody = () => {
        if (body !== undefined) {
            let tableJ1 = [];
            let tableJ2 = [];

            body.forEach((body, index) => {
                if (tableJ1.length === 0) {
                    tableJ1.push(body);
                    return;
                }
                let status = false;
                tableJ1.forEach(s => {
                    if (s.text === body.text) status = true;
                })
                if (status) {
                    tableJ1.push(body);
                    return;
                } else {
                    tableJ2.push(body);
                }

            })

            return (
                <>
                    {tableJ1.length > 0 &&
                        <div>
                            <p className="onboard-table-newui-title-header">{tableJ1[0].text}</p>
                            <table className="onboard-table-newui-table">
                                <thead>
                                <tr>
                                    {
                                        header.map((header, index) => {
                                            return (
                                                <td className="onboard-table-newui-title" key={index}>{header}</td>
                                            )
                                        })
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    tableJ1.map((value, index) => {
                                        return (
                                            <tr key={index}>
                                                {value.index === index &&
                                                    <td className="onboard-table-newui-val"
                                                        rowSpan={value.rowSpan}>{value.text}</td>}
                                                <td className="onboard-table-newui-sub">{value.sub}</td>
                                                <td className="onboard-table-newui-res">{value.result}</td>
                                            </tr>)
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    }
                    {tableJ2.length > 0 &&
                        <div>
                            <p className="onboard-table-newui-title-header m-t-24">{tableJ2[0].text}</p>
                            <table className="onboard-table-newui-table">
                                <thead>
                                <tr>
                                    {
                                        header.map((header, index) => {
                                            return (
                                                <td className="onboard-table-newui-title" key={index}>{header}</td>
                                            )
                                        })
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    tableJ2.map((value, index) => {
                                        return (
                                            <tr key={index}>
                                                {value.index === index &&
                                                    <td className="onboard-table-newui-val"
                                                        rowSpan={value.rowSpan}>{value.text}</td>}
                                                <td className="onboard-table-newui-sub">{value.sub}</td>
                                                <td className="onboard-table-newui-res">{value.result}</td>
                                            </tr>)
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    }
                </>
            );
        } else
            return <></>;
    }

    return (
        <div className="onboard-table-newui-root">
            {renderBody()}
        </div>
    )
};

export default OnboardTablePartner;
